const tokenKey = 'token';
const userEmailKey = 'userEmail';
const userIdKey = 'userId';
const userData = 'userData';

// Whether this tab has had a signed-in session since it loaded. A tab that
// never had one (login page, sign-in return page) has nothing to end when
// another tab signs out.
let sessionSeen = false;

const setToken = (token, userEmail, userId) => {
  sessionSeen = true;
  localStorage.setItem(tokenKey, token);
  localStorage.setItem(userEmailKey, userEmail);
  localStorage.setItem(userIdKey, userId);
};

const getToken = () => {
  const token = localStorage.getItem(tokenKey);
  if (token) sessionSeen = true;
  return token;
};

const hadSession = () => sessionSeen;

const setUserInfo = (data) => {
  localStorage.setItem(userData, JSON.stringify(data));
};

const setAuthenticatedSession = ({ token, user, keepKeycloakSession = false }) => {
  if (!token || !user?.email || !user?.id) {
    throw new Error('The authentication response is incomplete.');
  }

  // An SSO exchange can switch identities in an already-open browser. Remove
  // the previous user's workspace and cached account context before storing
  // the fresh target session.
  // A Keycloak session (stored by oidc-client-ts) belongs to the sign-in
  // being completed only when the caller says so; any other sign-in drops it.
  const keycloakSession = keepKeycloakSession
    ? Object.keys(localStorage)
        // Also where that session was started, which sign-out falls back on.
        .filter((key) => key.startsWith('oidc.user:') || key === 'tmr.signIn.server')
        .map((key) => [key, localStorage.getItem(key)])
    : [];
  localStorage.clear();
  keycloakSession.forEach(([key, value]) => localStorage.setItem(key, value));
  setToken(token, user.email, user.id);
  setUserInfo(user);
};

const getUserInfo = (data) => {
  return localStorage.getItem(userData);
};

const clearStorage = () => {
  localStorage.clear();
};

export default {
  setToken,
  getToken,
  hadSession,
  setUserInfo,
  setAuthenticatedSession,
  getUserInfo,
  clearStorage,
};
